import React, { useState, useEffect } from "react";
import axios from "axios";
import { FormattedMessage } from "react-intl";
import { Icon, TextLink } from "blueprints2";

function Header({ workspace, locale }) {
  const [migrated, setMigrated] = useState(false);
  const [emailId, setEmailId] = useState("");
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const feedbackLink = process.env.REACT_APP_FEEDBACK_URL;

  useEffect(() => {
    // set dev name in header - TODO add to context so accessible throughout
    axios
      .get(`/${workspace}/developer`, { withCredentials: true })
      .then((res) => {
        setEmailId(res.data.email);

        // check if dev has completed migration
        const devMeta = JSON.parse(res.data.meta);
        setMigrated(devMeta.migrated);
      });
  }, [workspace]);

  return (
    <header className="site-header">
      <div className="w-full block flex-grow justify-between flex items-center w-auto p-6">
        <div>
          <div>
            <a href="/">
              <img
                className="h-12"
                src={process.env.REACT_APP_LOGO}
                alt={process.env.REACT_APP_TITLE}
              />
            </a>
          </div>
        </div>

        <div>
          <nav role="navigation">
            {process.env.NODE_ENV === "development" && (
              <strong>{`workspace: ${process.env.REACT_APP_WORKSPACE}`}</strong>
            )}
            <input
              type="checkbox"
              id="header_nav"
              className="menu-toggle-checkbox"
            />
            <li>
              <TextLink
                href={`/documentation/${locale}/affiliate_apis`}
                newWindow
              >
                <FormattedMessage id="header.react.link_6" />
              </TextLink>
            </li>
            <li>
              <TextLink href="/guides/try_out_apis">
                <FormattedMessage id="header.react.link_7" />
              </TextLink>
            </li>
            <li className="has-dropdown ml-4">
              <FormattedMessage id="header.react.link_8" />
              <Icon
                type="chevron-up"
                className={menuIsOpen ? "inline" : "hidden"}
              />
              <Icon
                type="chevron-down"
                className={menuIsOpen ? "hidden" : "inline"}
              />
              <ul
                className="dropdown"
                aria-label="submenu"
                onMouseEnter={() => setMenuIsOpen(true)}
                onMouseLeave={() => setMenuIsOpen(false)}
              >
                <li className="mt-2 mr-4 font-semibold cursor-text">
                  <span>{emailId}</span>
                </li>
                <li className="dropitem">
                  <TextLink href="/default/dashboard/applications">
                    <FormattedMessage id="header.react.link_0" />
                  </TextLink>
                </li>
                <li className="dropitem">
                  <TextLink href="/default/dashboard/settings">
                    <FormattedMessage id="header.react.link_1" />
                  </TextLink>
                </li>
                <li className="dropitem">
                  <TextLink href={feedbackLink} newWindow>
                    <FormattedMessage
                      id={
                        process.env.REACT_APP_WORKSPACE === "jp"
                          ? "FAQ"
                          : "header.react.link_3"
                      }
                    />
                  </TextLink>
                </li>
                <li className="dropitem">
                  <TextLink href="/logout">
                    <FormattedMessage id="header.react.link_4" />
                  </TextLink>
                </li>
              </ul>
            </li>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
